import React, { Component } from 'react';
import './styles.css';

class Winners extends Component {
  render(){
    return (
      <div className="winners-container">
        <div>
          <div className="winners-header">
            <h3 className="Light">ADIDAS HQ</h3>
            <h3>WINNERS FINAL ROUND</h3>
            <p className="date">02 - 03/07/2018</p>
          </div>
          <div className="winners-main">
            <p><strong>The winning team from each location will qualify for the final competition</strong>, taking place at the adidas global HQ in Germany. All 4 teams will experience the 3-stripe culture and have the chance to pitch their concept to our senior IT leaders. The winner will receive an exclusive grand prize package.</p>
          </div>
        </div>
      </div>
    );
  }
}

export default Winners;



// WEBPACK FOOTER //
// ./src/components/Winners/Winners.js